import ReactPaginate from 'react-paginate';
import { oneLine } from 'common-tags';

import ChevronLeft from '@/icons/light/chevron-left.svg';
import ChevronRight from '@/icons/light/chevron-right.svg';

import type { FunctionComponent } from 'react';
import type { TypePaginationProps } from './types';

export const Pagination: FunctionComponent<TypePaginationProps> = ({
  className = '',
  disabled = false,
  onPageChange,
  pageRangeDisplayed = 2,
  pageCount,
  renderOnZeroPageCount = () => null,
}: TypePaginationProps) => (
  <ReactPaginate
    previousLabel={
      <ChevronLeft
        width={24}
        height={24}
        className="flex flex-row items-center gap-3 text-neutrals-900"
      />
    }
    nextLabel={
      <ChevronRight
        width={24}
        height={24}
        className="flex flex-row items-center gap-3 text-neutrals-900"
      />
    }
    pageClassName="flex flex-row gap-3 items-center justify-center p-1 text-center h-10 w-10 text-body text-body--l [&_a]:text-text-neutrals-900"
    activeClassName="flex flex-row gap-3 items-center bg-secondary-500 rounded-lg text-secondary-900 text-body text-body--l cursor-pointer"
    disabledClassName="pointer-events-none text-neutrals-300 opacity-40"
    onPageChange={onPageChange}
    pageRangeDisplayed={pageRangeDisplayed}
    pageCount={pageCount}
    renderOnZeroPageCount={renderOnZeroPageCount}
    marginPagesDisplayed={0}
    breakLabel={null}
    className={oneLine`
      flex flex-row items-center gap-3 
      ${disabled ? 'pointer-events-none opacity-40' : ''}  
      ${className}
    `}
  />
);

Pagination.displayName = 'Pagination';
